var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwoArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Glyph",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6 19a1 1 0 0 1 -.71-.29l-4-4a1 1 0 0 1 -.21-1.09 1 1 0 0 1 .92-.62h20a1 1 0 0 1 0 2h-17.59l2.3 2.29a1 1 0 0 1 0 1.42 1 1 0 0 1 -.71.29zm16-8h-20a1 1 0 0 1 0-2h17.59l-2.3-2.29a1 1 0 0 1 1.42-1.42l4 4a1 1 0 0 1 .21 1.09 1 1 0 0 1 -.92.62z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoArrow);
export default __webpack_public_path__ + "static/media/two_arrow.c7bbad59cf2e9cc827f047dc0eb554c1.svg";
export { ForwardRef as ReactComponent };